import DashboardIcon from "@mui/icons-material/Dashboard";
import ListAltIcon from "@mui/icons-material/ListAlt";
import CampaignIcon from "@mui/icons-material/Campaign";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import LogoutIcon from "@mui/icons-material/Logout";

const ALL_LINKS = [
    { href: "/admin", label: "Dashboard", icon: DashboardIcon },
    { href: "/list", label: "All Coupons", icon: ListAltIcon },
    { href: "/add_campaign", label: "Campaign", icon: CampaignIcon },
    { href: "/create_coupon", label: "Create Coupon", icon: ConfirmationNumberIcon },
    { href: "/used", label: "Used Coupons", icon: CheckCircleIcon },
    { href: "/delete", label: "Deleted Records", icon: DeleteIcon, variant: "danger" },
    { href: "/admin_logout", label: "Logout", icon: LogoutIcon },
];

/** Admin nav links for a page, optionally hiding the current route. */
export const getAdminNavLinks = (currentPath, { excludeCurrent = true } = {}) => {
    const links = ALL_LINKS.filter((link) => {
        if (link.href === "/admin_logout") return true;
        if (excludeCurrent && link.href === currentPath) return false;
        return true;
    });
    return links;
};
